import { DownloadFile, enqueueSnackbar, UploadFile } from 'actions';

import {
	GenerateTrxReductionRequest
} from '../requests/TrxReductionRequests.js';

export const SET_TRX_REDUCTION_FORM_STATE = 'SET_TRX_REDUCTION_FORM_STATE';

const onSetFormState = (value) => ({
	type: SET_TRX_REDUCTION_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

// Calls the API and downloads the zip that comes back.
// The request is { siteIds, fileLocation, planName } - only one of the first two is filled.
const Generate = (request) => async (dispatch) => {
	await GenerateTrxReductionRequest(request).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

// Site ids typed in the text box.
export const GenerateTrxReductionFromText = (siteIds, planName) => async (dispatch) => {
	await dispatch(Generate({ siteIds: siteIds, planName: planName }));
};

// Site ids inside a txt file: the file is uploaded first, then the API receives its location.
export const GenerateTrxReductionFromFile = (file, planName) => async (dispatch) => {
	await UploadFile(file).then(async (response) => {
		await dispatch(Generate({ fileLocation: response.data, planName: planName }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
